<a [libLoading]="loading" class="download-link" [class.disabled]="loading" (click)="download()">{{fileName}}</a>
